import { ILookupItem } from "./LookupItem";
export enum ItemValueType
{
    Units = 1,
    Dollars = 2,
    WholeNumber = 3,
    Accounts = 4,
    Text = 5,
    Percent = 6
}
export interface IPerformanceItem extends ILookupItem {
    performanceItemCategoryId: string;
    valueType: ItemValueType;
    summationType?: SummationType;
}

export enum SummationType {
    Add = 1,
    Subtract = 2
}